import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@softwaredev_cegeka/stix-core'
import Badge from '@softwaredev_cegeka/stix-core/dist/components/Badge'

const AdBadge = () => {
    return (
        <Badge variant={'info'} style={{ marginRight: '5px' }}>
            AD linked
        </Badge>
    )
}

const PublicBadge = () => {
    return (
        <Badge variant={'info'} style={{ marginLeft: '5px' }}>
            Public
        </Badge>
    )
}

function DrawerHeader({ path, title, isAD, isPublic = false }) {
    return (
        <div>
            {isAD ? <AdBadge /> : null}
            <span>{title}</span>
            {isPublic ? <PublicBadge /> : null}
            <Link className={'edit-link'} to={path}>
                <Icon icon="edit" />
                <span>Edit</span>
            </Link>
        </div>
    )
}

export default DrawerHeader
